<template>
    <!--
    Component based in https://megalomaniacslair.co.uk/pairing-simplemde-and-vuejs/
     -->
    <div>
        <textarea ref="area"></textarea>
    </div>
</template>

<script>
    export default {
        name: "easymde",
        data(){
          return {
              mdeInstance: null
          }
        },
        props: ['value'],
        mounted() {
            // eslint-disable-next-line no-undef
            this.mdeInstance = new EasyMDE({
                element: this.$refs.area, // Tie EasyMDE to your textarea
                // Set your SimpleMDE configuration here
                // e.g. remove the status bar (status: false), customise the
                // toolbar (toolbar: ["bold", "italic", "heading"]) or similar
            })
            const self = this
            this.mdeInstance.codemirror.on('change', function() {
                // Catch on change events
                self.$emit('input', self.mdeInstance.value())
            })
        },
        watch: {
            // Setup a watch to track changes,
            // and only update when changes are made
            value(newVal){
                if (newVal !== this.mdeInstance.value()){
                    this.mdeInstance.value(newVal)
                }
            }
        },
        beforeDestroy() {
            // Clean up when the component gets destroyed
            this.mdeInstance.toTextArea()
        }
    }
</script>

<style scoped>
</style>
